// Copyright (c) 2026 Riddle, LLC. All rights reserved.
// Author: Ray Harris

import { currentRouteUrl } from "../../router/navigation";
import { rememberReturnTo } from "../../routes/returnTo";
import { getRouteByPath } from "../../types/routing";
import { connectionCallbackConnector } from "../../utils/connectorCallback";
import { loadPage } from "./loadPage";

export const SIGN_IN_HANDOFF_KEY = "riddle.auth.signInHandoff";
export const SIGN_IN_HANDOFF_TTL_MS = 60_000;
export const SIGN_IN_SURFACE_PATH = "/";

let handedOffThisLoad = false;

export function isOnSignInSurface(): boolean {
  const pathname = window.location.pathname;
  return getRouteByPath(pathname).key === "login" && connectionCallbackConnector(pathname) === null;
}

export function handOffToSignInSurface(): void {
  rememberReturnTo(currentRouteUrl());
  try {
    window.sessionStorage.setItem(SIGN_IN_HANDOFF_KEY, String(Date.now()));
  } catch {
  }
  loadPage(SIGN_IN_SURFACE_PATH);
}

export function takeSignInHandoff(): boolean {
  let raw: string | null;
  try {
    raw = window.sessionStorage.getItem(SIGN_IN_HANDOFF_KEY);
    window.sessionStorage.removeItem(SIGN_IN_HANDOFF_KEY);
  } catch {
    return false;
  }
  const startedAt = Number(raw);
  const age = Date.now() - startedAt;
  const isFresh = raw !== null && Number.isFinite(startedAt) && age >= 0 && age <= SIGN_IN_HANDOFF_TTL_MS;
  if (isFresh) {
    handedOffThisLoad = true;
  }
  return isFresh;
}

export function wasHandedOffThisLoad(): boolean {
  return handedOffThisLoad;
}

export function clearSignInHandoff(): void {
  try {
    window.sessionStorage.removeItem(SIGN_IN_HANDOFF_KEY);
  } catch {
  }
}

export function __resetSignInHandoffForTests(): void {
  handedOffThisLoad = false;
}

export function isInteractionInProgressError(error: unknown): boolean {
  const code = (error as { errorCode?: unknown } | null | undefined)?.errorCode;
  return code === "interaction_in_progress";
}
